import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { AppBar, CssBaseline, Drawer, Hidden, IconButton, Toolbar } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { colors, Avatar } from 'kangarootime-ui';
import MenuSVG from '../../../assets/svg/menu';
import DrawerContent from './Drawer';
import ProfileDropdownMenu from './ProfileDropdownMenu';

const drawerWidth = 200;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  grow: {
    flexGrow: 1
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0
    },
    backgroundColor: colors.brand_1
  },
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`
    },
    backgroundColor: '#FFFFFF'
  },
  menuButton: {
    marginRight: 20,
    [theme.breakpoints.up('sm')]: {
      display: 'none'
    }
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: colors.brand_1
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing.unit
  }
});

class withNavigationBars extends PureComponent {
  constructor (props) {
    super(props);

    this.state = {
      mobileOpen: false,
      profileDropdownMenuAnchor: null,
      margins: 64
    };
  }

  componentDidMount = () => {
    this.applyMarginForDevice();

    window.addEventListener('resize', () => this.applyMarginForDevice());
  }

  componentWillUnmount = () => {
    window.removeEventListener('resize', () => this.applyMarginForDevice());
  }

  handleDrawerToggle = () => {
    this.setState(state => ({ mobileOpen: !state.mobileOpen }));
  }

  applyMarginForDevice = () => {
    let marginsToSet = 32;
    let hasMobileDimensions = window.innerWidth <= 600;

    if (hasMobileDimensions) {
      marginsToSet = 16;
    }

    if (this.state.margins !== marginsToSet) {
      this.setState({ margins: marginsToSet });
    }
  }

  render () {
    const { classes, theme } = this.props;

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBar position='fixed' className={classes.appBar}>
          <Toolbar>
            <Hidden smUp implementation='css'>
              <IconButton
                color='inherit'
                aria-label='Open drawer'
                onClick={this.handleDrawerToggle}
                className={classes.menuButton}
              >
                <MenuSVG fill={colors.brand_1} />
              </IconButton>
            </Hidden>
            <div className={classes.grow} />
            <IconButton onClick={event => this.setState({ profileDropdownMenuAnchor: event.currentTarget })}>
              <Avatar size='lg' image={this.props.profilePicture} />
            </IconButton>
          </Toolbar>
        </AppBar>
        <ProfileDropdownMenu
          anchorEl={this.state.profileDropdownMenuAnchor}
          handleDismiss={() => this.setState({ profileDropdownMenuAnchor: null })}
          logout={this.props.logout}
          centerSwitcher={{
            centerId: this.props.centerId,
            centers: this.props.centers,
            switchCenter: this.props.switchCenter
          }}
        />
        <nav className={classes.drawer}>
          <Hidden smUp implementation='css'>
            <Drawer
              container={this.props.container}
              variant='temporary'
              anchor={theme.direction === 'rtl' ? 'right' : 'left'}
              open={this.state.mobileOpen}
              onClose={this.handleDrawerToggle}
              classes={{
                paper: classes.drawerPaper
              }}
            >
              <DrawerContent />
            </Drawer>
          </Hidden>
          <Hidden xsDown implementation='css'>
            <Drawer
              classes={{
                paper: classes.drawerPaper
              }}
              variant='permanent'
              open
            >
              <DrawerContent />
            </Drawer>
          </Hidden>
        </nav>
        <main className={classes.content} style={{ margin: this.state.margins }}>
          <div className={classes.toolbar} />
          { this.props.children }
        </main>
      </div>
    );
  }
}

function mapStateToProps (state) {
  return {
    profilePicture: state.identity.profilePicture,
    centers: state.identity.centers,
    centerId: state.identity.centerId,
    name: state.identity.name,
    email: state.identity.email
  };
}

function mapDispatchToProps (dispatch) {
  return {
    logout: () => dispatch({ type: 'LOGOUT_REQUEST' }),
    switchCenter: (centerId) => dispatch({ type: 'SWITCH_ACTIVE_CENTER', centerId })
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles, { withTheme: true })(withNavigationBars));
